module.exports = __webpack_public_path__ + "docs/cookies.c068f90ff78204a4e86b4a184cb7862b.html";